import { render } from "./Mailing.vue?vue&type=template&id=06eac6a2"
import script from "./Mailing.vue?vue&type=script&lang=js"
export * from "./Mailing.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__